import {withRouter} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import Row from '../tag/Row';
import {ServiceAlert} from './ServiceAlert';
import Span from "../tag/Span";
import {FormattedMessage} from "react-intl";
import Loader from "../Loader";
import Api from '../../api/Api';
import {isFeatureOn} from "../../definitions/Config";

let {id: module_id} = module;

const FlowmedikCareConversation = () => {

    const [careConversationLink, setCareConversationLink] = useState(null);

    useEffect(() => {
        Api.getCareConversationLink()
            .then((data) => {
                if (data) {
                    setCareConversationLink(data);
                }
            })
            .catch((err) => {
                console.log(err)
            });
    }, [setCareConversationLink]);

    if (!careConversationLink) {
       return <Loader/>
    } else {
        return (
            <div className={'ot-careconversations-main'}>
                {isFeatureOn('careconversation.servicebreak') && (
                    <Row>
                        <ServiceAlert/>
                    </Row>)}
                <Span>
                    <p>
                        <FormattedMessage id={`${module_id}.description`}/>
                    </p>
                </Span>
                <iframe src={careConversationLink}
                        width="100%" height="800px" frameBorder="0"></iframe>
            </div>
        );
    }
}

export default withRouter(FlowmedikCareConversation);
